import {
  CapaQuotationServiceType,
  CapaPcbService,
  CapaPcbServiceType
} from '@generated/graphql';

const isDesignService = (
  serviceType?: CapaQuotationServiceType,
  pcbService?: CapaPcbService[]
) => {
  if (pcbService && pcbService.length > 1) {
    return (
      serviceType === CapaQuotationServiceType.Design ||
      (pcbService ?? []).some(
        (service) => service.serviceType === CapaPcbServiceType.CircuitDesign
      )
    );
  }

  return serviceType === CapaQuotationServiceType.Design;
};

export default isDesignService;
